import styled from 'styled-components'

export const BreadcrumbWrapper = styled.div`
  margin: 2rem 0;
  font-weight: 400;
`

export const StyledLink = styled.span`
  text-decoration: underline;
`
